/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Yes
 *
 * 1 = No
 *
 * 2 = InProgress
 *
 * 3 = NotRequirement
 */
export enum RiskAssessmentStatus {
  Yes = 0,
  No = 1,
  InProgress = 2,
  NotRequirement = 3,
}
